import './subtype_filter_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.PostSourceTypeFilterView extends Monitoring.Views.SocialContents.Filters.SubtypeFilterView

  getAppliedValues: ->
    @searchQuery.get('post_source_type')

  addFilter: (value) ->
    @searchQuery.addPostSourceType(value)
